import { render } from "./Empty Bins.vue?vue&type=template&id=050b4130"
import script from "./Empty Bins.vue?vue&type=script&lang=js"
export * from "./Empty Bins.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__